/* eslint-enable no-undef */
<template>
  <div 
    style="background-color: #111"
    class="">
    <!-- :style="{
      backgroundImage: 'url(' + CertificateBg + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain',
    }" -->

    <div class="certificate-data-list">
      <div class="wrapper">
        <div 
            v-if="!isLoadnig"
            class="bg-loader center-block">
            <img src="/assets/images/loading/loading_1.svg" alt="">    
        </div>
        <div v-else class="center-block text-center">
          <div class="text-white f-20 font-bold text-center margin-bt-20">Файл готов</div>
          <button 
            class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            @click="generatePdf">Скачать</button>

        </div>
      </div>
    </div>

    <div
      class="pm-certificate-container"
    >
      <div 
        style="display: inline-block"
        ref='contentToPrint'
        class="wrapper relative">

        <img class="main-img" :src="CertificateBg" alt="">
        <div 
        style="font-family: Times New Roman, sans-serif;"
        class="user-title">
          <span class="pm-name-text bold">{{ user.fio }}</span>
        </div>

        <div 
          style="font-family: Times New Roman, sans-serif;"
          class="curse-title">
          <span class="pm-credits-text block">
            <b>{{ course.title }}</b>
          </span>
        </div>

        <div
          style="font-family: Times New Roman, sans-serif;"
          class="code-block1">
          {{ code  }}
        </div>

        <div class="month-day month-day-1">
          {{ date_start_month }}.{{ date_start }} - {{ date_end_month }}.{{ date_end }}
        </div>

        <div
          style="font-family: Times New Roman, sans-serif;"
          class="result-score">
          <!-- <span class="pm-earned-text block cursive"
            >Итоговый бал: <b>{{ estimate }}</b></span
          > -->
        </div>
        <div class="qr-code-block">
          <div>
            <h3 style="font-family: Times New Roman, sans-serif">
              <!-- <b>{{ code }}</b> -->
            </h3>
          </div>
          <qrcode-vue
            :value="getCertitificateText()"
            :size="135"
            :level="level"
            :render-as="renderAs"
          />
        </div>

        
      </div>      
    </div>


  </div>
</template>

<script>
import { API_CLIENT, HEADERS_TOKEN_JSON } from "@/const/uri";
import axios from "axios";
import CertificateBg from "@/assets/img/certificate/cert_1.png";
import QrcodeVue from "qrcode.vue";
import html2pdf from 'html2pdf.js';
import { FRON_HOST } from "@/const/uri.dev";

export default {
  components: {
    QrcodeVue,
  },
  data() {
    return {
      CertificateBg,
      user: {},
      estimate: null,
      code: null,
      date_end_month: null,
      date_start_month: null,
      date_end: null,
      date_start: null,
      course: {},
      isLoadnig: true, 
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    generatePdf() {
      const element = this.$refs.contentToPrint;
      const options = {
        margin: [0, 0, 0, 0],
        filename: 'Сертификат.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'b4', orientation: 'landscape' }
      };
      html2pdf().from(element).set(options).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        if (totalPages > 1) {
          // Remove the second page
          pdf.deletePage(2);
        }
        // Save the modified PDF
        const pdfBlob = pdf.output('bloburl');
        // Open the PDF in a new tab
        window.open(pdfBlob, '_blank');
        pdf.save(options.filename);
        // Return the modified PDF
        return pdf;
      });
    },
    getCertitificateText() {
      const uuid = this.$route.params.uuid;
      const url = `${FRON_HOST}/client/certificate/${uuid}`;
      return url;
    },
    async loadData() {
      await axios({
        method: "GET",
        params: {
          course_uuid: this.$route.params.uuid,
          user_id: this.$route.params.userId,
        },
        url: API_CLIENT.certificate,
        headers: HEADERS_TOKEN_JSON(),
      })
        .then((e) => {
          this.user = e.data.data.user;
          this.estimate = e.data.data.estimate;
          this.code = e.data.data.code;
          this.course = e.data.data.course;
          this.date_end = e.data.data.date_end;
          this.date_start = e.data.data.date_start;
          this.date_end_month = e.data.data.date_end_month;
          this.date_start_month = e.data.data.date_start_month;
          // this.generatePdf();
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  props: {},
};
</script>

<style scoped>
/* @import url("https://fonts.googleapis.com/css?family=Open+Sans|Pinyon+Script|Rochester"); */
.btn-download {
  position: absolute;
  right: 15px;
  top: 15px;
}
.month-line {
  position: absolute;
  top: 222px;
  font-weight: bold;
  font-size: 19px;
}
.month-day {
  position: absolute;
  left: 235px;
  font-size: 19px;
}
.month-day-1 {
  bottom: 72px;
}
.month-day-2 {
  bottom: 75px;
}
.month-day-3 {
  left: 277px;
  bottom: 95px;
}
.month-day-4 {
  bottom: 75px;
  left: 277px;
}
.code-block1 {
  position: absolute;
  top: calc(293px - 13px);
  left: 541px;
  font-weight: 500;
  font-size: 18px;
}
.curse-title {
  position: absolute; 
  left: 0;
  top: calc(620px - 15px);
  font-size: 33px;
  width: 100%;
  text-align: center;
}
.month1-year {
  left: 400px;
}
.month1-str {
  left: 273px;
}
.month2-str {
  left: 475px;
}
.month2-year {
  left: 600px;
}
.user-title {
  position: absolute;
  /* top: 356px; */
  top: calc(464px - 25px);
  left: 0;
  width: 100%;
  text-align: center;
}
.pm-name-text {
  font-size: 38px;
  font-weight: 500!important;
}
.result-score {
  position: absolute;
  top: 535px;
  left: 0;
  width: 100%;
  font-size: 22px;
  /* font-style: italic; */
  text-align: center;
}
.qr-code-block {
  position: absolute;
  width: auto;
  top: calc(715px - 10px);
  left: 232px;
  text-align: right;
  display: flex;
  justify-content: start;
  align-items: start;
  flex-direction: column;
}
.cursive {
  font-family: "Pinyon Script", cursive;
}
.sans {
  font-family: "Open Sans", sans-serif;
}
.bold {
  font-weight: bold;
}
.block {
  display: block;
}
.underline {
  border-bottom: 1px solid #777;
  padding: 5px;
  margin-bottom: 15px;
}
.margin-0 {
  margin: 0;
}
.padding-0 {
  padding: 0;
}
.pm-empty-space {
  height: 40px;
  width: 100%;
}
body {
  padding: 20px 0;
  background: #ccc;
}
.pm-earned-text {
  font-size: 20px;
}
.main-img {
  width: 1350px;
  height: 1110px;
  height: auto;
}
.pm-certificate-container {
  position: relative;
  /* width: 900px;
  height: 635px; */
  /* background-color: #618597; */
  color: #333;
  font-family: "Open Sans", sans-serif;
}
.pm-certificate-container .outer-border {
  width: 794px;
  height: 594px;
  position: absolute;
  left: 50%;
  margin-left: -397px;
  top: 50%;
  margin-top: -297px;
  border: 2px solid #fff;
}
.pm-certificate-container .inner-border {
  width: 730px;
  height: 530px;
  position: absolute;
  left: 50%;
  margin-left: -365px;
  top: 50%;
  margin-top: -265px;
  border: 2px solid #fff;
}
.pm-certificate-container .pm-certificate-border {
  position: relative;
  width: 720px;
  height: 520px;
  padding: 0;
  border: 1px solid #e1e5f0;
  background-color: rgba(255, 255, 255, 1);
  background-image: none;
  left: 50%;
  margin-left: -360px;
  top: 50%;
  margin-top: -260px;
}
.pm-certificate-container .pm-certificate-border .pm-certificate-block {
  width: 650px;
  height: 200px;
  position: relative;
  left: 50%;
  margin-left: -325px;
  top: 70px;
  margin-top: 0;
}
.pm-certificate-container .pm-certificate-border .pm-certificate-header {
  margin-bottom: 10px;
}
.pm-certificate-container .pm-certificate-border .pm-certificate-title {
  position: relative;
  top: 40px;
}
.pm-certificate-container .pm-certificate-border .pm-certificate-title h2 {
  font-size: 34px !important;
}
.pm-certificate-container .pm-certificate-border .pm-certificate-body {
  padding: 20px;
}
.pm-certificate-container
  .pm-certificate-border
  .pm-certificate-body
  .pm-name-text {
  font-size: 25px;
}
.pm-certificate-container .pm-certificate-border .pm-earned {
  margin: 15px 0 20px;
}
.pm-certificate-container .pm-certificate-border .pm-earned .pm-earned-text {
  font-size: 20px;
}
.pm-certificate-container .pm-certificate-border .pm-earned .pm-credits-text {
  font-size: 15px;
}
.pm-certificate-container
  .pm-certificate-border
  .pm-course-title
  .pm-earned-text {
  font-size: 20px;
}
.pm-certificate-container
  .pm-certificate-border
  .pm-course-title
  .pm-credits-text {
  font-size: 15px;
}
.pm-certificate-container .pm-certificate-border .pm-certified {
  font-size: 12px;
}
.pm-certificate-container .pm-certificate-border .pm-certified .underline {
  margin-bottom: 5px;
}
.pm-certificate-container .pm-certificate-border .pm-certificate-footer {
  width: 650px;
  height: 100px;
  position: relative;
  left: 50%;
  margin-left: -325px;
  bottom: -105px;
}
</style>
/* eslint-enable no-undef */
